import { Grid, makeStyles, Theme, Typography } from "@material-ui/core";
import { observer } from "mobx-react";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { Button } from "@roc/ui";
import { AppraisalReassignmentLetterStore } from "libs/feature-documents/src/documents/stores/documentForms/appraisalReassignmentLetterStore";

const useStyles = makeStyles((theme: Theme)=>{
  return{
    container: {
      flexDirection: 'column',
      justifyContent: 'center',
      textAlign: 'center',
      marginTop: '20px',
    },
    checkIcon: {
      fontSize: '100px',
      color:'green'
    },
    margins: {
      marginTop: '20px',
    },
  };
});

export type AppraisalReassignmentLetterSignedProps = {
  store: AppraisalReassignmentLetterStore;
};

export const AppraisalReassignmentLetterSigned = observer((props: AppraisalReassignmentLetterSignedProps)=>{
  const classes = useStyles();
  const processComplete = true;
  const { store } = props;

  return (
    <Grid container className={classes.container}>
      <Grid item>
        <CheckCircleIcon className={classes.checkIcon}/>
        <Typography variant="h2">
          Process Completed!
          <br/>
        </Typography>
      </Grid>
      <Grid item className={classes.margins}>
        <Typography>
          The appraisal reassignment letter process has been completed.
        </Typography>
        <Typography>Your information was successfully received.</Typography>
      </Grid>
      {store.isSigned && (
        <Grid item>
          <Button
            testId={'download'}
            variant={'outlined'}
            color={'primary'}
            onClick={() => store.downloadSignedAppraisalLetter(store.loanId, store.propertyId)}
            style={{
              marginTop: 16,
              marginBottom: 8
            }}
          >
            Download Appraisal Reassignment Letter
          </Button>
        </Grid>
      )}
    </Grid>
  )
})